<template>
    <div id="SrtEditor2" v-if="subtitles_active.length > 0">
      
        <!-- Glass -->
        <SubtitleLineData :index="-1" :data="{}" class="fakeItem fakeItem-1" v-if="beforeSegments.length == 0"/> 
        <SubtitleLineData :index="-1" :data="{}" class="fakeItem fakeItem-2" v-if="beforeSegments.length == 0"/>
        <SubtitleLineData :index="beforeSegments[0].store_index" :data="beforeSegments[0]" class="fakeItem fakeItem-1" v-if="beforeSegments.length != 0"/> 
        <SubtitleLineData :index="beforeSegments[1].store_index" :data="beforeSegments[1]" class="fakeItem fakeItem-2" v-if="beforeSegments.length != 0"/>
        
        <subtitle-editor-glass class="selectItem"/>

        <SubtitleLineData :index="-1" :data="{}" class="fakeItem fakeItem-3" v-if="afterSegments.length == 0"/>    
        <SubtitleLineData :index="-1" :data="{}" class="fakeItem fakeItem-4" v-if="afterSegments.length == 0"/>    
        <SubtitleLineData :index="afterSegments[0].store_index" :data="afterSegments[0]" class="fakeItem fakeItem-3" v-if="afterSegments.length != 0"/> 
        <SubtitleLineData :index="afterSegments[1].store_index" :data="afterSegments[1]" class="fakeItem fakeItem-4" v-if="afterSegments.length != 0"/>
        
      <!-- Revision Mode Controller -->
      <revision-mode-controller />
    </div>
    <div id="SrtEditor2" v-else>
      <div style="width: 100%; margin: auto; text-align: center;">
        <svg style="margin-top: 10rem; height: 200px;" id="b21613c9-2bf0-4d37-bef0-3b193d34fc5d" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" width="647.63626" height="632.17383" viewBox="0 0 647.63626 632.17383"><path d="M687.3279,276.08691H512.81813a15.01828,15.01828,0,0,0-15,15v387.85l-2,.61005-42.81006,13.11a8.00676,8.00676,0,0,1-9.98974-5.31L315.678,271.39691a8.00313,8.00313,0,0,1,5.31006-9.99l65.97022-20.2,191.25-58.54,65.96972-20.2a7.98927,7.98927,0,0,1,9.99024,5.3l32.5498,106.32Z" transform="translate(-276.18187 -133.91309)" fill="#f2f2f2"/><path d="M725.408,274.08691l-39.23-128.14a16.99368,16.99368,0,0,0-21.23-11.28l-92.75,28.39L380.95827,221.60693l-92.75,28.4a17.0152,17.0152,0,0,0-11.28028,21.23l134.08008,437.93a17.02661,17.02661,0,0,0,16.26026,12.03,16.78926,16.78926,0,0,0,4.96972-.75l63.58008-19.46,2-.62v-2.09l-2,.61-64.16992,19.65a15.01489,15.01489,0,0,1-18.73-9.95l-134.06983-437.94a14.97935,14.97935,0,0,1,9.94971-18.73l92.75-28.4,191.24024-58.54,92.75-28.4a15.15551,15.15551,0,0,1,4.40966-.66,15.01461,15.01461,0,0,1,14.32032,10.61l39.0498,127.56.62012,2h2.08008Z" transform="translate(-276.18187 -133.91309)" fill="#3f3d56"/><path d="M398.86279,261.73389a9.0157,9.0157,0,0,1-8.61133-6.3667l-12.88037-42.07178a8.99884,8.99884,0,0,1,5.9712-11.24023l175.939-53.86377a9.00867,9.00867,0,0,1,11.24072,5.9707l12.88037,42.07227a9.01029,9.01029,0,0,1-5.9707,11.24072L401.49219,261.33887A8.976,8.976,0,0,1,398.86279,261.73389Z" transform="translate(-276.18187 -133.91309)" fill="#48546a"/><circle cx="190.15351" cy="24.95465" r="20" fill="#48546a"/><circle cx="190.15351" cy="24.95465" r="12.66462" fill="#fff"/><path d="M878.81836,716.08691h-338a8.50981,8.50981,0,0,1-8.5-8.5v-405a8.50951,8.50951,0,0,1,8.5-8.5h338a8.50982,8.50982,0,0,1,8.5,8.5v405A8.51013,8.51013,0,0,1,878.81836,716.08691Z" transform="translate(-276.18187 -133.91309)" fill="#e6e6e6"/><path d="M723.31813,274.08691h-210.5a17.02411,17.02411,0,0,0-17,17v407.8l2-.61v-407.19a15.01828,15.01828,0,0,1,15-15H723.93825Zm183.5,0h-394a17.02411,17.02411,0,0,0-17,17v458a17.0241,17.0241,0,0,0,17,17h394a17.0241,17.0241,0,0,0,17-17v-458A17.02411,17.02411,0,0,0,906.81813,274.08691Zm15,475a15.01828,15.01828,0,0,1-15,15h-394a15.01828,15.01828,0,0,1-15-15v-458a15.01828,15.01828,0,0,1,15-15h394a15.01828,15.01828,0,0,1,15,15Z" transform="translate(-276.18187 -133.91309)" fill="#3f3d56"/><path d="M801.81836,318.08691h-184a9.01015,9.01015,0,0,1-9-9v-44a9.01016,9.01016,0,0,1,9-9h184a9.01016,9.01016,0,0,1,9,9v44A9.01015,9.01015,0,0,1,801.81836,318.08691Z" transform="translate(-276.18187 -133.91309)" fill="#48546a"/><circle cx="433.63626" cy="105.17383" r="20" fill="#48546a"/><circle cx="433.63626" cy="105.17383" r="12.18187" fill="#fff"/></svg>
      </div>
      <div style="width: 100%; margin-top: 1rem; text-align: center; color: #48546a; font-size: 2rem">
        <span>Nada encontrado</span>
      </div>
    </div>
</template>

<script>
// Components
import SubtitleEditorGlass from "../SubtitleEditorGlass";
import SubtitleLineData from "../SubtitleLineData";
import RevisionModeController from "../RevisionModeController";

// Store's
import { createNamespacedHelpers } from "vuex";
import { mapState } from "vuex";
const { mapGetters } = createNamespacedHelpers("srt");

export default {
    components:{
        SubtitleEditorGlass,
        SubtitleLineData,
        RevisionModeController
    },
    data(){
        return{          
            subtitles_active: [],  
            beforeSegments: [],
            afterSegments: [],
        }
    },
    watch:{
      async current_index(){
        await this.updateGlassPosition();
      },
      async segments_filter(){
        this.updateSubtitleActive('select'); 
        await this.updateGlassPosition();       
        this.$emit('changeScrollHeigth', this.subtitles_active)    
      },
      async subtitles(){
        this.updateSubtitleActive();
        await this.updateGlassPosition();
      },
      async live_length(){
        this.updateSubtitleActive();
        await this.updateGlassPosition();
      },    
    },
    computed:{            
        live_length(){     
            return this.subtitles_length
        },       
        segments_filter(){
            return this.$store.state.controller.segments_filter
        },    
        ...mapGetters([             
            "subtitles",                               
            "current_index",
            "subtitles_length",
            "max_index",
            "subtitle_length",
            "last_segment_modified"
        ])
    },
    methods:{
        updateSubtitleActive(event='update'){
          this.subtitles_active = []
          if(this.segments_filter == 'all'){
            this.subtitles_active = this.subtitles  
            this.$store.dispatch('controller/setCurrentSegmentIndex', this.subtitles_active[this.current_index].store_index)        
          }else if(this.segments_filter == "saved"){

            let saved_segments = this.subtitles.filter(e => e.is_saved == true || e.is_saved == 'true')
            this.subtitles_active = saved_segments 
  
            if(event == 'select'){              
              this.$store.dispatch('controller/setCurrentSegmentIndex', this.subtitles_active[0].store_index)  
            }else{             
              this.$store.dispatch('controller/setCurrentSegmentIndex', this.getSegmentBeforeRender())               
            } 

          } else {
            let unsaved_segments = this.subtitles.filter(e => e.is_saved == false || e.is_saved == 'false' || e.is_saved == undefined)
            this.subtitles_active = unsaved_segments
            if(event == 'select'){
              this.$store.dispatch('controller/setCurrentSegmentIndex', this.subtitles_active[0].store_index)  
            }else{
              this.$store.dispatch('controller/setCurrentSegmentIndex', this.getSegmentBeforeRender())        
            }

          } 

          this.$emit('changeScrollHeigth', this.subtitles_active)
        },  
        async updateGlassPosition(){
          this.beforeSegments = []
          this.afterSegments = []
        
          // BEFORE CURRENT SEGMENT
          if(this.current_index == this.subtitles_active[0].store_index){
            this.beforeSegments = []
          } else if(this.current_index == this.subtitles_active[1].store_index){
            let subtitle = await this.getSegmentByPosition(this.current_index, -1)
            this.beforeSegments = [{}, subtitle]
          }else{
            let pos2 = await this.getSegmentByPosition(this.current_index, -2)
            let pos1 = await this.getSegmentByPosition(this.current_index, -1)
            this.beforeSegments = [pos2, pos1]
          }

          // AFTER CURRENT SEGMENT
          if(this.current_index == this.subtitles_active[this.subtitles_active.length - 1].store_index){
            this.afterSegments = []
          } else if(this.current_index == this.subtitles_active[this.subtitles_active.length - 2].store_index){
            let subtitleAfter = await this.getSegmentByPosition(this.current_index, 1)
            this.afterSegments = [subtitleAfter, {}]
          }else{
            let pos2After = await this.getSegmentByPosition(this.current_index, 2)
            let pos1After = await this.getSegmentByPosition(this.current_index, 1)
            this.afterSegments = [pos1After, pos2After]
          }
        },
        async getSegmentByPosition(current_index, position){            
            let subtitles = this.subtitles_active
            for(let i=0; i<subtitles.length; i++){
              if((subtitles[i].store_index) == current_index){  
                return subtitles[(i+position)]                           
              }
            }
        },
        getSegmentBeforeRender(){
          let length = this.subtitles_active.length
          for(let i=0; i<length; i++){
            if(this.subtitles_active[i].store_index >= this.current_index){
              return this.subtitles_active[i].store_index
            }
          }
          return this.subtitles_active[length-1].store_index
        }
      },
  }
</script>

<style lang="scss">

#SrtEditor2 {
  position: absolute;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 66%;
  font-size: 1.15vw; 
  background-color: var(--bg-color) !important;
  color: var(--font-color) !important;
  .fakeItem{
      width: 100%;
      min-height: 20%;
      max-height: 20%;
  }
    .fakeItem-1{
        top:0;
    }
    .fakeItem-2{
        top: 19%;
    }
    .fakeItem-3{
        bottom: 19%;
    }
    .fakeItem-4{
        bottom: 0;
    }
    
    
}

#SrtEditor2 > div {
  display: flex;
  justify-content: center;
  align-items: stretch;
  flex: 2;
  width: 100%;
}

#SrtEditor2 > div:not(:first-child) {
  border-top: 1px solid white;
}
#SrtEditor2 > div:first-child {
  flex: 0.5;
  font-size: 1.1vw;
}

#SrtEditor2 > div > div {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#SrtEditor2 > div > div:not(:first-child),
#SrtEditor2 > div:not(:first-child) {
  border-left: 1px solid white;
}

#SrtEditor2 > div > div:first-child {
  flex: 5%;
}
#SrtEditor2 > div > div:nth-child(2) {
  flex: 15%;
}
#SrtEditor2 > div > div:nth-child(3),
#SrtEditor2 > div > div:nth-child(4) {
  flex: 40%;
}
#SrtEditor2 > div > div:nth-child(5) {
  align-items: stretch;
}




</style>